import { Check } from "lucide-react";

// Availability communicated via text + icon + color (never color alone).
export function AvailabilityBadge({ available, className = "", testId }) {
  if (available) {
    return (
      <span
        data-testid={testId}
        className={`inline-flex items-center gap-1.5 rounded-full border border-nm-green/30 bg-nm-green-soft px-2.5 py-1 text-xs font-semibold text-nm-green ${className}`}
      >
        <Check className="h-3.5 w-3.5" strokeWidth={3} />
        Tersedia
      </span>
    );
  }
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border border-nm-border bg-nm-surface2 px-2.5 py-1 text-xs font-semibold text-nm-muted ${className}`}
    >
      Habis
    </span>
  );
}
